import { AdminRoyalRingsPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    AdminRoyalRingsPage,
    '/admin-royal-rings',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['agency-owner', 'internal-admin', 'internal-staff', 'system-admin']),
    ],
    {
      name: 'Royal Ring Recipients',
    }
  ),
]
